/* eslint-env browser */

/**
 * GDPR banner and cookie policy implementation
 */

(function () {
    // Variables
    var TELEMETRY_PREFERENCE = "InsertTelemetry";
    var TELEMETRY_PREFERENCE_DATE = "TelemetryDate";

    var gdprBanner = document.querySelector('#gdpr-banner');
    var acceptBtn = $('#accept-btn');
    var declineBtn = $('#decline-btn');
    var cookieModalAcceptBtn = $('#cookie-settings-modal-accept');
    var cookieModalDeclineBtn = $('#cookie-settings-modal-reject');
    var cookieSettingsModal = document.querySelector('#cookie-settings-modal');
    var cookieSettingsBtn = $('#cookie-settings-btn');
    var cookieSettingsFooterBtn = $('#cookie-settings-footer-btn');
    var closeCookieSettingsBtn = $('#close-cookie-settings-modal-btn');

    // Function to allow/decline telemetry
    var allowTelemetryAndCloseBanner = function () {
      gdprBanner.classList.add('hidden');
      hideCookieSettings();
      setTelemetryPreference(true);
      insertTelemetry();
    }
    var declineTelemetryAndCloseBanner = function () {
      gdprBanner.classList.add('hidden');
      hideCookieSettings();
      setTelemetryPreference(false);
      window.location.reload();
    }
    
    // Functions to hide/show cookie banner
    var showCookieSettings = function () {
      cookieSettingsModal.classList.remove('hidden');
    }
    var hideCookieSettings = function () {
      cookieSettingsModal.classList.add('hidden');
    }

    // Listeners
    $(acceptBtn).click(allowTelemetryAndCloseBanner);
    $(cookieModalAcceptBtn).click(allowTelemetryAndCloseBanner);
    $(declineBtn).click(declineTelemetryAndCloseBanner);
    $(cookieModalDeclineBtn).click(declineTelemetryAndCloseBanner);
    $(cookieSettingsBtn).click(showCookieSettings);
    $(cookieSettingsFooterBtn).click(showCookieSettings);
    $(closeCookieSettingsBtn).click(hideCookieSettings);

    // Function to update localStorage based on the users' preference
    function setTelemetryPreference(accepted) {
      localStorage.setItem(TELEMETRY_PREFERENCE, JSON.stringify(accepted));
      localStorage.setItem(TELEMETRY_PREFERENCE_DATE, JSON.stringify(Date.now()));
    }

    // Function to check if the stored date is > 6 months old
    var isConsentStale = function (timestamp) {
      var consent_date = new Date(parseInt(timestamp * 1000));
      var today = new Date();

      var six_months_in_ms = 1000/*ms*/ * 60/*s*/ * 60/*min*/ * 24/*h*/ * 30/*days*/ * 6/*months*/;
      return today - consent_date > six_months_in_ms;
    }

    // Function to check the existing telemetry status
    // Returns true/false if user accepted/denied telemetry.
    // Returns null if user never accepted/denied or consent is stale.
    function getTelemetryPreference() {
      var telemetryPref = localStorage.getItem(TELEMETRY_PREFERENCE);
      var consentIsStale = isConsentStale(localStorage.getItem(TELEMETRY_PREFERENCE_DATE));

      if (telemetryPref == null || consentIsStale) return null

      return telemetryPref == "true"
    }

    // Function to insert the analytics if telemetry preference is true
    function insertTelemetry() {
      (function () {
        var analytics = (window.analytics = window.analytics || []);
        if (!analytics.initialize)
          if (analytics.invoked)
            window.console &&
              console.error &&
              console.error("Segment snippet included twice.");
          else {
            analytics.invoked = !0;
            analytics.methods = [
              "trackSubmit",
              "trackClick",
              "trackLink",
              "trackForm",
              "pageview",
              "identify",
              "reset",
              "group",
              "track",
              "ready",
              "alias",
              "debug",
              "page",
              "once",
              "off",
              "on",
              "addSourceMiddleware",
              "addIntegrationMiddleware",
              "setAnonymousId",
              "addDestinationMiddleware",
            ];
            analytics.factory = function (e) {
              return function () {
                var t = Array.prototype.slice.call(arguments);
                t.unshift(e);
                analytics.push(t);
                return analytics;
              };
            };
            for (var e = 0; e < analytics.methods.length; e++) {
              var key = analytics.methods[e];
              analytics[key] = analytics.factory(key);
            }
            analytics.load = function (key, e) {
              var t = document.createElement("script");
              t.type = "text/javascript";
              t.async = !0;
              t.src =
                "https://cdn.segment.com/analytics.js/v1/" +
                key +
                "/analytics.min.js";
              var n = document.getElementsByTagName("script")[0];
              n.parentNode.insertBefore(t, n);
              analytics._loadOptions = e;
            };
            analytics._writeKey = "6zHVpK7baGIwXSy9gSs1EZVe7fplXEJ3";
            analytics.SNIPPET_VERSION = "4.13.2";
            analytics.load("6zHVpK7baGIwXSy9gSs1EZVe7fplXEJ3");
            analytics.page();
          }
      })();
    }

    // Time to check the existing telemetry status, and act accordingly
    var pref = getTelemetryPreference();
    switch (pref) {
      case true:
        gdprBanner.classList.add('hidden');
        insertTelemetry();
        return;

      case false:
        gdprBanner.classList.add('hidden');
        return;

      case null:
        gdprBanner.classList.remove('hidden');
        return;

      default:
        console.log(`Unexpected telemetry preference: ${pref}`);
        return;
    }
})();
